import { defineComponent as n, openBlock as m, createBlock as r, unref as v, mergeProps as h, withCtx as p, createElementVNode as e } from "vue";
import { RevIcon as l } from "@ds/components/Icon";
const u = /* @__PURE__ */ n({
  name: "IconCommentWithSparkles",
  __name: "IconCommentWithSparkles",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const o = t;
    return (s, a) => (m(), r(v(l), h(o, { "view-box": "0 0 24 24" }), {
      default: p(() => [...a[0] || (a[0] = [
        e("path", { d: "M5.5 2.25h6.704a.75.75 0 0 1 0 1.5H5.5A1.75 1.75 0 0 0 3.75 5.5v9a1.75 1.75 0 0 0 1.75 1.75h1a1.25 1.25 0 0 1 1.25 1.25v1.94l3.645-2.917a1.25 1.25 0 0 1 .78-.273H18.5a1.75 1.75 0 0 0 1.75-1.75v-2.905a.75.75 0 0 1 1.5 0V14.5a3.25 3.25 0 0 1-3.25 3.25h-6.236l-4.795 3.836A.75.75 0 0 1 6.25 21v-3.25H5.5a3.25 3.25 0 0 1-3.25-3.25v-9A3.25 3.25 0 0 1 5.5 2.25m12.756 2.505a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 1.5 0v2M19.25 7.27a.75.75 0 0 1 0-1.5h2a.75.75 0 0 1 0 1.5h-2" }, null, -1),
        e("path", { d: "M13.748 7.27a.75.75 0 0 1 0-1.5h2a.75.75 0 0 1 0 1.5h-2m4.502 2.98a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 1.5 0v2m-8.753-1a.75.75 0 1 0 1.5 0v-1a.75.75 0 0 0-1.5 0v1m1.5 4a.75.75 0 0 1-1.5 0v-1a.75.75 0 0 1 1.5 0v1m.753-1.75a.75.75 0 0 1 0-1.5h1a.75.75 0 0 1 0 1.5h-1m-4 0a.75.75 0 0 1 0-1.5h1a.75.75 0 0 1 0 1.5h-1" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
